<template>
    <ThumbBase
        class="VideoPreview"
        :image="video.thumbnail"
        :title="video.title"
        :subtitle="video.channelTitle"
        icon="play-triangle"
        ellipsis
        @click="gotoVideo()"
    >
        <LifeskillNumberTag
            slot="tags"
            class="lifeskillTag"
            :lifeskill-id="video.lifeskillId || video.lifeskillIds[0]"
        />
    </ThumbBase>
</template>

<script>
import ThumbBase from './ThumbBase';
import LifeskillNumberTag from './LifeskillNumberTag';

export default {
    components: { ThumbBase, LifeskillNumberTag },
    props: {
        videoId: {
            type: String,
            required: true
        },
        lifeskillId: {
            type: String
        }
    },
    computed: {
        video() {
            return this.$store.getters['moduleApp/getVideoById'](this.videoId);
        }
    },
    methods: {
        gotoVideo() {
            this.$router.push({
                name: 'DashboardVideoView',
                params: {
                    videoId: this.videoId,
                    lifeskillId: this.lifeskillId || this.video.lifeskillIds[0]
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
$transitionDuration: 0.3s;

$thumbnailHeight: 10em;

.VideoPreview {
    width: (286em / 15); // 19em;
    // height: 14em;
    // width: $thumbnailHeight / (9/16);
    height: 13em;
    // &:hover {
    //   .thumbnail {
    //     transform: scale(1.1);
    //   }
    // }
    /deep/ .image {
        background-size: 125%; //cover;
    }
}

.thumbnail {
    position: relative;
    background-color: $dashboard-itemBackground;
    background-size: 104%; //cover;
    background-position: center;
    // border-radius: 0.5em;
    // transition: transform $transitionDuration;

    height: 8em;

    // &::after {
    //   content: "";
    //   display: block;
    //   padding-top: percentage(9/16);
    // }
}

.lifeskillTag {
    position: absolute;
    top: 1em;
    left: 1em;
}
</style>
